import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { API } from "../../api/dmsApi";
import config from "../../config";

import { store } from "../../store/store";

import { showLoader } from "../reducer/commonReducer";
// export interface RoleState {
// //   dashBoardData: any;
// //   totalCount: number;
//   status: "idle" | "loading" | "failed";
// }
const initialState: any = {
//   dashBoardData: [],
//   totalCount: 0,
  //status: "idle",
};


export const OnLoginAsyncForOBS = createAsyncThunk("auth/signInOSB", async () => {
  store.dispatch(showLoader({ isLoader: true }));
  const result:any = await API.Post(
    `${config.BASE_URL_OBS}/OnlineBooking/signInOSB`,
    {
      ...config.OSBLogin,
    }
  );
  if (result) {
    store.dispatch(showLoader({ isLoader: false }));
  }
  return result?.data
});

export const regNo = createAsyncThunk(
  "feedback/getFeedbackData",
  async (request: any) => {
    store.dispatch(showLoader({ isLoader: true }));
    const result: any = await API.Post(
      `${config.BASE_URL_OBS}/OnlineBooking/IsRegistrationNoValid`,
      {
        ...request,
      }
    );
    if (result) {
      store.dispatch(showLoader({ isLoader: false }));
    }

    return result?.data;
  }
);

export const getQuery = createAsyncThunk(
  "feedback/state",
  async (request: any) => {
    store.dispatch(showLoader({ isLoader: true }));
    const result: any = await API.Post(
      `${config.BASE_URL_OBS}/OnlineBooking/Query`,
      {
        ...request,
      }
    );
    if (result) {
      store.dispatch(showLoader({ isLoader: false }));
    }

    return result?.data;
  }
);
export const createAppointment = createAsyncThunk(
  "feedback/create",
  async (request: any) => {
    store.dispatch(showLoader({ isLoader: true }));
    const result: any = await API.Post(
      `${config.BASE_URL_OBS}/OnlineBooking/CreateAppointment`,
      {
        ...request,
      }
    );
    if (result) {
      store.dispatch(showLoader({ isLoader: false }));
    }

    return result.data;
  }
);
export const getMobileOTP = createAsyncThunk(
  "feedback/state",
  async (request: any) => {
    store.dispatch(showLoader({ isLoader: true }));
    const result: any = await API.Post(
      `${config.BASE_URL_OBS}/ExAPIs/api/OnlineBooking/SendOTP`,
      {
        ...request,
      }
    );
    if (result) {
      store.dispatch(showLoader({ isLoader: false }));
    }

    return result;
  }
);
export const verifyOTP = createAsyncThunk(
  "feedback/otp",
  async (request: any) => {
    store.dispatch(showLoader({ isLoader: true }));
    const result: any = await API.Post(
      `${config.BASE_URL_OBS}/ExAPIs/api/OnlineBooking/VerifyOTP`,
      {
        ...request,
      }
    );
    if (result) {
      store.dispatch(showLoader({ isLoader: false }));
    }

    return result;
  }
);

export const holidayListApi = createAsyncThunk(
  "feedback/getFeedbackData",
  async (request: any) => {
    store.dispatch(showLoader({ isLoader: true }));
    const result: any = await API.Post(
      `${config.BASE_URL_OBS}/OnlineBooking/IsHoliday`,
      {
        ...request,
      }
    );
    if (result) {
      store.dispatch(showLoader({ isLoader: false }));
    }

    return result?.data;
  }
);

export const feedbackFormSlice: any = createSlice({
    name: "feedbackReducer",
    initialState,
    reducers: {
     
    },
    extraReducers: (builder: any) => {
      builder
      .addCase(OnLoginAsyncForOBS.pending, (state: any) => {
        state.status = "loading";
      })
      .addCase(OnLoginAsyncForOBS.fulfilled, (state: any, action: any) => {
        state.status = "idle";
        state.authData = [];
        state.authData = action.payload;
      })
      .addCase(OnLoginAsyncForOBS.rejected, (state: any) => {
        state.status = "failed";
        state.authData = [];
      });
    },
  });
  export default feedbackFormSlice.reducer;